import React from 'react';
import CouponsTable from './Components/CouponsTable';

const CouponsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <CouponsTable />
      </div>
    </div>
  );
};

export default CouponsPage;
